import React  from 'react';
import { withRouter } from 'react-router';
import storageService from '../../shared/services/StorageService';

/* Redux Import Start */
import { connect } from 'react-redux';
/* Redux Import End */

function guardIsAllowed(Component) {
    class isAllowedComponent extends React.Component {  

        /**
         * componentWillMount()
         * This function Executes just before rendering takes place.
         */
        componentWillMount = async() => {
            this.checkAuth();
        }

        /**
         * checkAuth()
         * This function will act as a guard to redirect based on the conditions.
         */
        checkAuth = async() => {
            
            const { accessToken, lockedAccess, quickAccessUser, activeTab } = this.props;
            let accessTokenfromStore = await storageService.getSessionStorageItem("accessToken");   
            const location = this.props.location;
            const redirect = location.pathname + location.search;

            if ( accessTokenfromStore === null) {
                window.location.href = '/login';
            } else if(lockedAccess === true || quickAccessUser === true) {
                window.location.href = '/request-bungii';
            } else if(accessToken === '' || accessToken === null) {
                window.location.href = '/login';
            } else if(activeTab === 'getEstimate' && redirect !== '/request-bungii') {
                window.location.href = '/request-bungii';
            }else if(activeTab === 'deliveryDetails' && redirect !== '/delivery-details') {
                window.location.href = "/delivery-details";
            }else if(activeTab === 'done' && redirect !== '/success') {
                window.location.href = "/success";
            }
        }

        render() {
            const { accessToken } = this.props;
            return accessToken
            ? <Component { ...this.props } />
            : null;
        }
    }
    
    return connect(
        (
            { 
                user: {
                    accessToken, quickAccessUser
                },
                common: {
                    lockedAccess,
                    activeTab,
                }
            }
        ) => 
        (
            {
                accessToken,
                lockedAccess,
                quickAccessUser,
                activeTab,
            }
        ),
        ''
    )(withRouter(isAllowedComponent));
}

export default guardIsAllowed;